import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useAllPatientDocuments = (patientId, dpcType) => {
  const tenant =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  const fetchPatientDocuments = async () => {
    if (!patientId) return [];
    const axiosInstance = createAxiosInstance();
    const response = await axiosInstance.get(
      `${tenant}/document/getbypatientid/${patientId}`
    );

    return response.data;
  };

  return useQuery({
    queryKey: ["patientAllDocuments", patientId, dpcType],
    queryFn: fetchPatientDocuments,
    enabled: !!patientId,
  });
};
